import storefront from "../../global/storefront";
import generateGroupsQuery from "./generateGroupsQuery";
import generateCacheName from "../generateCacheName";
import unwrapProducts from "../unwrapProducts";
import addProductHelpers from "../addProductHelpers";

const BATCHING_DELAY = 100;

const groupsCache = {};
let groupsQueue = [];
let timeout = null;

export default function fetchGroup(name) {
  const cacheName = generateCacheName(name);

  if (cacheName in groupsCache) return Promise.resolve(groupsCache[cacheName]);

  let resolveGroupData;
  const groupData = new Promise((resolve) => {
    resolveGroupData = resolve;
  });

  const newGroupQueueItem = {
    name,
    resolve: resolveGroupData,
  };

  groupsQueue.push(newGroupQueueItem);

  if (timeout === null) {
    timeout = setTimeout(() => {
      timeout = null;

      const groupsToFetch = groupsQueue;

      groupsQueue = [];

      storefront
        .request({
          query: generateGroupsQuery(groupsToFetch),
        })
        .then(({ data }) => {
          // Add data to cache
          for (const [key, value] of Object.entries(data)) {
            // Sometimes the product isn't published to the storefront API so we get null
            if (value) {
              groupsCache[key] = unwrapProducts(value)
                // Filter out any products published to the storefront API but unavailable on the online store
                .filter(({ onlineStoreUrl }) => onlineStoreUrl !== null)
                .map(addProductHelpers);
            }
          }
          console.log("groupsCache", groupsCache);
          // Resolve pending promises with data
          groupsToFetch.forEach((group) => {
            const cacheName = generateCacheName(group.name);

            if (cacheName in groupsCache) {
              group.resolve(groupsCache[cacheName]);
            }
          });
        });
    }, BATCHING_DELAY);
  }

  return groupData;
}
